import { render, staticRenderFns } from "./IrCodes.vue?vue&type=template&id=72b3f572"
import script from "./IrCodes.vue?vue&type=script&lang=js"
export * from "./IrCodes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports